import React from 'react'
import styles from './TabellaCompatibilitaVolantiniModal.module.sass'
import { Modal } from '@components/atoms'
import { CategoriaNode } from '@gql/graphql'
import useTrans from '@hooks/useTrans'
import { TabellaCompatibilita } from '@components/molecules'

interface Props {
  className?: string
  id?: string
  open?: boolean
  onClose?: () => void
  titolo?: string
  sottoCategoria: CategoriaNode
}

const TabellaCompatibilitaVolantiniModal = (props: Props) => {
  const { className = '', id, open = false, onClose, sottoCategoria } = props

  const t = useTrans()

  return (
    <div className={`${styles.root} ${className}`}>
      <Modal
        id={id}
        open={open}
        onClose={onClose}
        title={t('Compatibilità accessori')}
        children={
          <div className={styles.modalContent}>
            {sottoCategoria?.tabellaCompatibilita?.map((tabella, i) => (
              <TabellaCompatibilita
                tabella={tabella}
                sottoCategoria={sottoCategoria}
                key={`tabella-${i}`}
              />
            ))}
          </div>
        }
        className={styles.modal}
      />
    </div>
  )
}

export default TabellaCompatibilitaVolantiniModal
